import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, CircularProgress, Typography } from '@mui/material';
import { ReactComponent as MagnifyingGlass } from '../../img/icons/warning-magnifying-glass.svg';
import { ReactComponent as WhiteMagnifyingGlass } from '../../img/icons/warning-magnifying-glass-white.svg';
import { UIContext } from '../../context/UIContext';
import ErrorLoadingData from '../ErrorLoadingData';
import { DataGridConfigContext } from '../../context/DataGridConfigContext';

const NoRows = () => {
  const { t } = useTranslation();
  const { isMobile, colorMode } = useContext(UIContext);
  const { data, fetchData, translationKey, isLoading, isError } = useContext(DataGridConfigContext);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        padding: `${isMobile ? '0 16px' : '0 24px'}`,
      }}
    >
      {isLoading || (data && data.length > 0) ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            margin: '96px',
          }}
        >
          <CircularProgress
            aria-label={t('components.loading.loadingRowData')}
            aria-live="polite"
            aria-busy={isLoading}
            data-testid="loading-icon"
            sx={{ color: 'text.secondary' }}
          />
        </Box>
      ) : (
        <>
          {isError && <ErrorLoadingData action={fetchData} />}
          {!isError && (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 2,
              }}
            >
              {colorMode === 'light' ? <MagnifyingGlass /> : <WhiteMagnifyingGlass />}
              <Typography variant="h2">{t(`screens.${translationKey}.noDataYet.title`)}</Typography>
              <Typography variant="body1">
                {t(`screens.${translationKey}.noDataYet.subtitle`)}
              </Typography>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default NoRows;
